import { ConsentMapping, updateConsentMode } from '../seo/datalayer.consent'
import { getCookie, setCookie } from './cookies'

export type Cookies = { [cookie in Cookie]: Accepted }

export const functionalCookies = 'functional-cookies'
export const analyticalCookies = 'analytical-cookies'
export const videoCookies = 'video-cookies'
export const trackingCookies = 'tracking-cookies'

export const cookies = [functionalCookies, analyticalCookies, videoCookies, trackingCookies] as const

export const requiredCookies = [functionalCookies, analyticalCookies]

export type Cookie = (typeof cookies)[number]

export type Accepted = typeof yes | typeof no
export const yes = 'yes'
export const no = 'no'

export const cookieToModeMapping: ConsentMapping<Cookie> = {
    'analytical-cookies': ['analytics_storage'],
    'functional-cookies': ['functionality_storage'],
    'video-cookies': [],
    'tracking-cookies': ['personalization_storage', 'ad_personalization', 'ad_storage', 'security_storage'],
}

export const getCurrentCookie = (cookie: Cookie): Accepted =>
  getCookie(cookie) == yes || requiredCookies.includes(cookie) ? yes : no


const updateConsent = updateConsentMode(cookieToModeMapping)

export const setConsentCookie = (cookie: Cookie, isAccepted: Accepted, exdays: number = 1000) => {
    updateConsent(cookie, isAccepted == 'yes')
    setCookie(cookie, isAccepted, exdays)
}
